import { Progress } from "../../../packages/fetcher/fetcherFunctions.js";

export const formatProgress = (progress: Progress) => {
  const totalMB = (progress.total / 1024 / 1024).toFixed(2);
  const loadedMB = (progress.loaded / 1024 / 1024).toFixed(2);

  return `${loadedMB} of ${totalMB} MB`;
};
